import { getVariationDraft } from "./selectors/getVariationDraft";
import { getVariationInitialDraft } from "./selectors/getVariationInitialDraft";
import { selectType } from "./thunks/selectType";
import { startInsertion } from "./thunks/startInsertion";
import { componentSlice } from "./slice";

const { _startInsertion, _initDraft, ...publicActions } =
  componentSlice.actions;

export const ComponentAction = {
  ...publicActions,
  startInsertion,
  selectType,
};

export const ComponentSelector = {
  ...componentSlice.selectors,
  getVariationDraft,
  getVariationInitialDraft,
};
